import { Navigate, useLocation, useParams } from 'react-router-dom';
import BookingCheckoutPage from '../components/booking/BookingCheckoutPage';

const PAGE_CONFIG = {
  flight: {
    title: 'Review Your Flight Booking',
    backLink: '/flight/search/flights',
    backLabel: 'Back to flight results',
  },
  hotel: {
    title: 'Review Your Hotel Booking',
    backLink: '/flight/search/hotels',
    backLabel: 'Back to hotel results',
  },
  car: {
    title: 'Review Your Car Rental',
    backLink: '/flight/search/cars',
    backLabel: 'Back to car results',
  },
  package: {
    title: 'Review Your Package Booking',
    backLink: '/flight/search/packages',
    backLabel: 'Back to package results',
  },
  cruise: {
    title: 'Review Your Cruise Booking',
    backLink: '/flight/search/cruises',
    backLabel: 'Back to cruise results',
  },
};

const VALID_TYPES = new Set(Object.keys(PAGE_CONFIG));

export default function BookPage() {
  const { type } = useParams();
  const { state } = useLocation();

  if (!VALID_TYPES.has(type) || !state?.payload) {
    return <Navigate to="/flight" replace />;
  }

  const config = PAGE_CONFIG[type];

  return (
    <BookingCheckoutPage
      serviceType={type}
      payload={state.payload}
      title={config.title}
      backLink={config.backLink}
      backLabel={config.backLabel}
    />
  );
}
